import { Map, List } from 'immutable';

import {
  RECOMMENDED_UTILITY_LIST_REQUEST,
  RECOMMENDED_UTILITY_LIST_SUCCESS,
  RECOMMENDED_UTILITY_LIST_FAILURE,
  RECOMMENDED_UTILITY_READ_REQUEST,
  RECOMMENDED_UTILITY_READ_SUCCESS,
  RECOMMENDED_UTILITY_READ_FAILURE,
  RECOMMENDED_UTILITY_UPDATE_REQUEST,
  RECOMMENDED_UTILITY_UPDATE_SUCCESS,
  RECOMMENDED_UTILITY_UPDATE_FAILURE,
  RECOMMENDED_UTILITY_CREATE_REQUEST,
  RECOMMENDED_UTILITY_CREATE_SUCCESS,
  RECOMMENDED_UTILITY_CREATE_FAILURE,
  RECOMMENDED_UTILITY_DELETE_REQUEST,
  RECOMMENDED_UTILITY_DELETE_SUCCESS,
  RECOMMENDED_UTILITY_DELETE_FAILURE,
  RECOMMENDED_UTILITY_FORM_DESTROY,
  RECOMMENDED_UTILITY_CSV_DOWNLOAD_REQUEST,
  RECOMMENDED_UTILITY_CSV_DOWNLOAD_SUCCESS,
  RECOMMENDED_UTILITY_CSV_DOWNLOAD_FAILURE,
} from './actions';
import Logger from '../../../lib/Logger';

export default function recommendedUtilities(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    'debug',
    `[recommendedUtilities.reducers] recommendedUtilities(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case RECOMMENDED_UTILITY_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case RECOMMENDED_UTILITY_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ['pages', action.order, action.limit, action.page],
          List(action.result)
        );

    case RECOMMENDED_UTILITY_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case RECOMMENDED_UTILITY_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case RECOMMENDED_UTILITY_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case RECOMMENDED_UTILITY_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case RECOMMENDED_UTILITY_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case RECOMMENDED_UTILITY_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case RECOMMENDED_UTILITY_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case RECOMMENDED_UTILITY_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case RECOMMENDED_UTILITY_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case RECOMMENDED_UTILITY_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case RECOMMENDED_UTILITY_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case RECOMMENDED_UTILITY_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case RECOMMENDED_UTILITY_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case RECOMMENDED_UTILITY_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set('form', action.form);

    case RECOMMENDED_UTILITY_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true,
      });

    case RECOMMENDED_UTILITY_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case RECOMMENDED_UTILITY_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `recommendedUtilities.reducers loaded.`);
